import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import ReviewPage from "./index"


export const VtReviewRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.REVIEW_PATH,
	title: VISIBILITY_TRACKER_ROUTES.REVIEW_TITLE,
	icon: 'magnifying-glass',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Review tagged banners with computed visibility scores',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <ReviewPage />,
		index: true
	}]
}
